'use strict';
// 服务器端地址
export default {
    // apiurl: 'http://192.168.1.241:8090/', //本地
    // apiurl: 'http://112.124.200.87:8081/hardware_webservice', //本地
    // apiurl: '/hardware_webservice', //本地
    //apiurl: 'http://www.xn--vhqv89amogm11a.com/hardware_webservice/', //本地
    apiurl: 'http://115.29.203.1:8045/hardware_webservice', //本地
  //apiurl2: 'app-api', //本地
    apiurl2: '/app-api', //本地
}